export const validateTelephoneNumber = (telephoneNumber) => {
    const re = /^\+?39\d{9,10}$/;
    return re.test(String(telephoneNumber));
}

export const validateTelephoneNumberWithoutPlus = (telephoneNumber) => {
    const re = /^39\d*/;
    return re.test(String(telephoneNumber));
}

export const validateSerial = (serial) => {
    const re = /^8939\d{15,16}$/;
    return serial === "" || re.test(String(serial));
}

export const validateTaxCode = (taxCode) => {
    const re = /^[a-zA-Z]{6}\d{2}[abcdehlmprstABCDEHLMPRST]\d{2}([a-zA-Z]\d{3})[a-zA-Z]$/;
    return re.test(String(taxCode));
}

export const validateVat = (vatNumber) => {
    const re = /^\d\d{6}(0{2}[1-9]|0[1-9]\d|100|120|121|888|999)\d$/;
    return re.test(String(vatNumber));
}

export const validatePhoneEntry = (phoneNumber) => {
    const regex = /^\+?\d{0,12}$/
    return regex.test(phoneNumber)
}

export const validatePhoneEntryWithPlusRequired = (phoneNumber) => {
    const regex = /^\+\d{0,12}$/
    return regex.test(phoneNumber)
}

export const validateSerialEntry = (serial) => {
    const regex = /^\d{0,20}$/
    return regex.test(serial)
}

export const validateVatOrTaxCodeEntry = (value) => {
    const regex = /^[a-zA-Z\d]{0,20}$/
    return regex.test(value)
}

export const onlyDigitWithPlus = (value) => {
    const regex = /^\+?\d*$/
    return regex.test(value)
}

export const onlyDigit = (value) => {
    const regex = /^\d*$/
    return regex.test(value)
}

export const validateEmail = (email) => {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\d-]+\.)+(it|com)))$/
        );
};

export const validateCredit = (value) => {
    const regex = /^[0-9]{0,3}([,.][0-9]{0,2})?$/
    return regex.test(value)
}

export const validateThresholdsEventsName = (name) => {
    const regex = /^[A-Za-z0-9 _\/\-+]+$/;
    return regex.test(name)
}
